export enum EFolderNature {
    NP = 'NP',
    PP = 'PP',
    DEM = 'DEM',
    USU = 'USU',
    NoCounterpart = 'Sans contrepartie',
}
